import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="video-publish"
//
// Opens the publish confirmation modal, lets the user narrow the music video's
// selected platforms, and submits only the ticked ones.
export default class extends Controller {
  static targets = [
    "modal", "dialog", "dspCheckbox", "error", "count",
    "publishButton", "publishButtonSpinner", "publishButtonText"
  ]

  // The publishing label comes from the page so it is translated there.
  static values = { publishingText: String }

  open() {
    if (!this.hasModalTarget) return

    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.updateCount()
  }

  close() {
    if (!this.hasModalTarget) return

    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  // Clicking the backdrop closes; clicking inside the dialog does not.
  closeOnBackdrop(event) {
    if (this.hasDialogTarget && this.dialogTarget.contains(event.target)) return

    this.close()
  }

  selectAll(event) {
    event.preventDefault()
    this.dspCheckboxTargets.forEach(checkbox => { checkbox.checked = true })
    this.updateCount()
  }

  deselectAll(event) {
    event.preventDefault()
    this.dspCheckboxTargets.forEach(checkbox => { checkbox.checked = false })
    this.updateCount()
  }

  get checkedCount() {
    return this.dspCheckboxTargets.filter(checkbox => checkbox.checked).length
  }

  // Publishing to nothing is not a valid request, so the button is disabled
  // until at least one DSP is ticked.
  updateCount() {
    if (!this.hasPublishButtonTarget) return

    const none = this.checkedCount === 0

    this.publishButtonTarget.disabled = none
    this.publishButtonTarget.classList.toggle("opacity-50", none)
    this.publishButtonTarget.classList.toggle("cursor-not-allowed", none)

    if (this.hasErrorTarget) {
      this.errorTarget.classList.toggle("hidden", !none)
    }

    this.updateLabel()
  }

  updateLabel() {
    if (!this.hasCountTarget) return

    const template = this.countTarget.dataset.template
    const total = this.countTarget.dataset.total
    if (!template) return

    this.countTarget.textContent = template
      .replace("__SELECTED__", this.checkedCount)
      .replace("__TOTAL__", total)
  }

  publish(event) {
    if (this.checkedCount === 0) {
      event.preventDefault()
      this.updateCount()
      return false
    }

    this.setPublishButtonLoading(true)
    return true
  }

  setPublishButtonLoading(loading) {
    if (!this.hasPublishButtonTarget) return

    this.publishButtonTarget.disabled = loading
    this.publishButtonTarget.classList.toggle("opacity-75", loading)
    this.publishButtonTarget.classList.toggle("cursor-not-allowed", loading)

    if (this.hasPublishButtonSpinnerTarget) {
      this.publishButtonSpinnerTarget.classList.toggle("hidden", !loading)
    }

    if (this.hasPublishButtonTextTarget && loading) {
      this.publishButtonTextTarget.textContent = this.hasPublishingTextValue
        ? this.publishingTextValue
        : window.I18n.t("albums.review.publish_modal.publishing")
    }
  }
}
